export default __webpack_public_path__ + "static/media/fail.56e91e32.svg";